import { useContext } from 'react';
import { WebSdkContext } from 'src/webSdk/WebSdkProvider';

export const useWebSdk = () => useContext(WebSdkContext);
